import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AutoSearchResult, AutoSearchResultType } from './auto-search.types';
import { getParams } from '../../common/common.func';

@Injectable()
export class AutoSearchService {
	private readonly searchUri = 'api/autoSearch';

	constructor(private _http: HttpClient) {}

	search(searchTerm?: string, type?: AutoSearchResultType): Promise<AutoSearchResult[]> {
		const params = getParams({ searchTerm, type });
		const options = { params: params };
		return this._http.get<AutoSearchResult[]>(this.searchUri, options).toPromise();
	}
}
